<template>
  <div :class="[className, 'p-6']">
    <div :class="innerClassName">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';
type Theme = 'normal' | 'beige';
type Props = {
  theme?: Theme;
  class?: string;
};
const props = withDefaults(defineProps<Props>(), {
  theme: 'normal',
  class: '',
});
const className = computed(() => `frame frame--${props.theme} ${props.class}`);
const innerBgColor = computed(() => {
  return props.theme === 'beige' ? 'bg-bg_frame' : 'bg-white';
});
const innerClassName = computed(
  () => `frame__inner h-full ${innerBgColor.value}`,
);
</script>

<style scoped>
.frame {
  position: relative;
  display: grid;
  width: 100%;
  max-width: 343px;
  margin-inline: auto;
  background-image: url('/images/frame/border-left-top.svg'),
    url('/images/frame/border-right-top.svg'),
    url('/images/frame/border-left-bottom.svg'),
    url('/images/frame/border-right-bottom.svg');
  background-repeat: no-repeat;
  background-position:
    left top,
    right top,
    left bottom,
    right bottom;
  background-size: 24px 24px;
}

.frame::before,
.frame::after {
  position: absolute;
  left: 24px;
  width: calc(100% - 24px * 2);
  height: 24px;
  content: '';
  background-repeat: repeat-x;
  background-size: 16px 24px;
}

.frame::before {
  top: 0;
  background-image: url('/images/frame/border-center-top.svg');
}

.frame::after {
  bottom: 0;
  background-image: url('/images/frame/border-center-bottom.svg');
}

.frame__inner::before,
.frame__inner::after {
  position: absolute;
  top: 24px;
  width: 24px;
  height: calc(100% - 24px * 2);
  content: '';
  background-repeat: repeat-y;
  background-size: 24px 204px;
}

.frame__inner::before {
  left: 0;
  background-image: url('/images/frame/border-left-center.svg');
}

.frame__inner::after {
  right: 0;
  background-image: url('/images/frame/border-right-center.svg');
}

.frame--beige {
  background-image: url('/images/frame/beige-border-left-top.svg'),
    url('/images/frame/beige-border-right-top.svg'),
    url('/images/frame/beige-border-left-bottom.svg'),
    url('/images/frame/beige-border-right-bottom.svg');
}

.frame--beige::before {
  background-image: url('/images/frame/beige-border-center-top.svg');
}

.frame--beige::after {
  background-image: url('/images/frame/beige-border-center-bottom.svg');
}

.frame--beige .frame__inner::before,
.frame--beige .frame__inner::after {
  background-size: 24px 11px;
}

.frame--beige .frame__inner::before {
  background-image: url('/images/frame/beige-border-left-center.svg');
}

.frame--beige .frame__inner::after {
  background-image: url('/images/frame/beige-border-right-center.svg');
}
</style>
